import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end mt-30" }
const _hoisted_2 = {
  key: 0,
  class: "ph-duotone ph-download text-black fs-16"
}
const _hoisted_3 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.download())),
        class: "cursor-pointer d-inline-flex text-decoration-none lh-1 text-muted fw-medium gap-2 align-items-center"
      }, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2))
          : (_openBlock(), _createBlock(_component_SpinnerLoading, {
              key: 1,
              class: "mb-0 h-auto",
              small: true
            })),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.download_patient_data')), 1 /* TEXT */)
      ]),
      _createCommentVNode(" ERRORS "),
      (_ctx.errors?.message ?? false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.message, (error) => {
              return (_openBlock(), _createElementBlock("p", {
                key: error,
                class: "small text-danger lh-1 m-0 mt-1"
              }, _toDisplayString(error), 1 /* TEXT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_AlertModal, {
      id: "alertModal",
      title: _ctx.$t('cta.download_patient_data'),
      dismissible: false,
      message: _ctx.message ?? _ctx.$t('feature.auth.$download_patient_data.success_message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}